

var _squid = require('squid');

require('xo-address-components/src/address-display/directive');

var _index = require('xo-models/src/checkout/index');

require('xo-page-components/src/aside-header/directive');

require('xo-tray-height/dist/directive');

require('xo-ui-components/src/accessibility/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSelectShipping', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            doneFn: '=?',
            backUri: '=?',
            shippingChangeFeature: '=?'
        },
        controller: ['$scope', function ($scope) {
            (0, _squid.$populate)($scope, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                checkoutShippingAddresses: _index.$CheckoutShippingAddressesModel.create($scope.token)
            }).then(function () {
                // Do not remove error message in review page when user does not change shipping address
                if (!($scope.checkoutSession.get('message.type') === 'error')) {
                    $scope.checkoutSession.message = null;
                }
                $scope.deleteShipping = function () {
                    if ($scope.backUri === 'checkout.shipTo') {
                        return false;
                    }
                    return $scope.checkoutShippingAddresses.addresses.some(function (address) {
                        return !(address.primary_address || address.default_address);
                    });
                };
            });

            $scope.onSelect = function (address) {
                if (!address.disable_for_transaction) {
                    address.action('select', {
                        resultModel: $scope.checkoutSession,
                        success: function success(result) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['smallToolTip.addressUpdated']
                            };
                            $scope.checkoutShippingAddresses.invalidate();

                            if ($scope.shippingChangeFeature && $scope.shippingChangeFeature.callOnShippingChange) {
                                $scope.shippingChangeFeature.callOnShippingChange(function () {
                                    $scope.doneFn(address);
                                });
                            } else {
                                $scope.doneFn(address);
                            }
                        }
                    });
                }
            };

            $scope.locale = _squid.$locale;
            $scope.addLink = function () {
                if ($scope.backUri === 'checkout.shipTo') {
                    return 'checkout.shipTo.sidebar.addShipping';
                }
                return 'checkout.review.sidebar.addShipping';
            };

            // Construct message object for block non-domestic shipping alert
            var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');
            var countryName = (0, _squid.$renderContent)('countryList.' + merchantCountry);
            var infoMessage = (0, _squid.$renderContent)('selectShipping.blockNonDomesticShippingInfo', {
                shippingCountry: countryName
            });

            $scope.blkNonDomesticShippingMsg = {
                msgs: [infoMessage],
                type: 'desc'
            };
        }]
    };
});

_squid.$locale;

_squid.$populate;

_squid.$renderContent;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_index.$CheckoutShippingAddressesModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/select-shipping/select-shipping/directive.js
// module id = ../node_modules/xo-member-components/src/select-shipping/select-shipping/directive.js
// module chunks = 0